import React, { Component } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from "react-slick"
import Fade from "react-reveal/Fade"
import { NextArrow, PrevArrow } from "./icons"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return <>{this.props.children}</>
  }
}

const ApplicationGallery = ({ title = "", darkMode, items }) => {
  const sliderRef = React.useRef(null)

  const settings = {
    speed: 600,
    fade: true,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    cssEase: "ease",
    swipe: false,
    focusOnSelect: false,
    adaptiveHeight: true,
    pauseOnHover: true,
  }

  return (
    <section className={`application-gallery ${darkMode ? "dark" : ""}`}>
      <Fade bottom distance={"40px"}>
        <div className="application-gallery__inner">
          {title && <h2 className="application-gallery__title">{title}</h2>}
          {items?.length > 0 && (
            <BlockUpdate>
              <Slider {...settings} ref={sliderRef}>
                {items?.map((el, i) => (
                  <div key={i}>
                    <div className="application-gallery__item">
                      {el.image.localFile && (
                        <GatsbyImage
                          image={getImage(el.image.localFile)}
                          alt={el.altText ? el.altText : "Headland Technology"}
                        />
                      )}
                      <div className="content">
                        <h3 className="content__title">{el.imageTitle}</h3>
                        <p className="content__blurb">{el.blurb}</p>
                        <div className="nav">
                          <PrevArrow
                            className="nav__arrow"
                            onClick={() => {
                              sliderRef.current.slickPrev()
                            }}
                          />
                          <div className="container">
                            {items?.map((el, dotIndex) => (
                              <div
                                key={dotIndex}
                                onClick={() => {
                                  sliderRef.current.slickGoTo(dotIndex)
                                }}
                                className={`nav__dot ${
                                  dotIndex === i ? "active" : ""
                                }`}
                              ></div>
                            ))}
                          </div>
                          <NextArrow
                            className="nav__arrow"
                            onClick={() => {
                              sliderRef.current.slickNext()
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </BlockUpdate>
          )}
        </div>
      </Fade>
    </section>
  )
}

export default ApplicationGallery
